import { render, staticRenderFns } from "./OutboundChart.vue?vue&type=template&id=1bddb05e&scoped=true"
import script from "./OutboundChart.vue?vue&type=script&lang=js"
export * from "./OutboundChart.vue?vue&type=script&lang=js"
import style0 from "./OutboundChart.vue?vue&type=style&index=0&id=1bddb05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bddb05e",
  null
  
)

export default component.exports